const PropTypes = require('prop-types');
const React = require('react');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
// @ components
const AccessKeyChangeStep1 = require('../accessKeyChangeSteps/accessKeyChangeStep1/accessKeyChangeStep1');
const AccessKeyChangeStep2 = require('../accessKeyChangeSteps/accessKeyChangeStep2/accessKeyChangeStep2');
// @ constants
const { PROC_CHANGE_ACCESS_CODE } = require('utilities/tagging.js');

const AccessKeyChange = props => {
    const {
        immAccessKeyChange,
        immProfile,
        validateStep,
        setField,
        setVisibleStep,
        setWillCancel,
        onFinish,
        onCancel
    } = props;
    const immSteps = immAccessKeyChange.get('steps');
    const stepsAmount = immSteps.size;
    const visibleStep = immAccessKeyChange.get('visibleStep');
    const immFinalButton = 'profileKeys-modifyButton';
    const step = immSteps.get(0);
    const validation = {
        confirmKeyIsValid: step.get('confirmKeyIsValid'),
        newKeyDirty: step.get('newKeyDirty'),
        newKeyIsValid: step.get('newKeyIsValid'),
        missedKeyTest: step.get('missedKeyTest')
    };
    const accessKeys = {
        confirmKey: step.get('confirmKey'),
        newKey: step.get('newKey')
    };
    const actions = {
        validateStep,
        setVisibleStep,
        setWillCancel,
        finish: onFinish,
        cancel: onCancel
    };

    return (
        <Wizard
            actions={actions}
            immSteps={immSteps}
            stepsAmount={stepsAmount}
            fullWidth={false}
            visibleStep={visibleStep}
            processType={PROC_CHANGE_ACCESS_CODE}
            showPreLeaveModal={true}
        >
            <WizardStep position="first" cancelButton={true} nextButton={true} >
                <AccessKeyChangeStep1
                    accessKeys={accessKeys}
                    setField={setField}
                    validation={validation}
                    immProfile={immProfile}
                />
            </WizardStep>
            <WizardStep
                position="last"
                addLoadingBehaviour={true}
                cancelButton={true}
                previousButton={true}
                finishButton={true}
                immFinalButton={immFinalButton}
            >
                <AccessKeyChangeStep2
                    immAccessKeyChange={immAccessKeyChange}
                />
            </WizardStep>
        </Wizard>
    );
};

AccessKeyChange.propTypes = {
    immAccessKeyChange: PropTypes.object,
    immProfile: PropTypes.object,
    onCancel: PropTypes.func,
    onFinish: PropTypes.func,
    setField: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
};

module.exports = AccessKeyChange;